GameView   = require("views/base/game")
Preloader  = require("lib/preload")
Easie      = require("lib/easie")
Device     = require("lib/device")

class GameElevatorView extends GameView
  template: require("./template")

  templates:
    container: require("./components/container")
    description: require("./components/description")

  events: ->
    "iostap .play-game": "enterGame"
    "iostap .goto-next": "next"
    "iostap .btn-attribute": "checkAnswer"
    "iostap .btn-continue": "hideDescription"

  initializeData: ->
    super

    @game.extra.set("fullscreen", true)
    @game.extra.set("sounds", true)

    { images } = @options.data
    
    images = (images or []).filter (i) ->
      i.image and _.compact(i.correct).length > 0

    images = images.map (i) ->
      i[p] = _.compact(i[p]) for p in ["correct", "incorrect"]
      i

    @setArray("variant", images)

    Preloader.load (image for { image } in images), (errors = []) =>
      @setArray "variant", _.reject images, (variant, i) ->
        _.include(errors, variant.image)

  initializeElements: ->
    super

    @setEl @findOne(".game-box"), "container"

  startGame: ->
    @answeredCount = 0
    super

  showNext: (isInitial) ->
    @unpauseGame() unless isInitial

    @game.timer.timestamp = Date.now()

    variant = @getRandom "variant"

    correct   = variant.correct
    incorrect =
      if @options.data.combine
        _.chain(@getArray("variant"))
          .without(variant)
          .pluck("correct")
          .flatten()
          .value()
      else
        variant.incorrect

    correct   = _.sample(correct, 4)
    incorrect = _.sample(incorrect, 4 - correct.length)

    @getEl("container").innerHTML = @templates.container
      title: variant.title
      image: variant.image
      correct: variant.correct
      all: _.chain().union(correct, incorrect).shuffle().value()

    @setEl(@getEl("container").querySelector(".game-image-container"), "image")
    @setEl(@getEl("container").querySelectorAll(".btn-attribute"), "answers")

    @transform @getEl("image"),
      opacity: 0
      x: "-100%"

    for el, i in @getEl("answers")
      @transform el,
        opacity: 0
        x: "100%"

    if @getEl("image").firstChild.complete
      @onImageLoad()
    else
      @getEl("image").firstChild.onload = => @onImageLoad()

  # It takes a small amount of time for the image to load, and until it does
  # we can't access it's height. The height dictates it's maximum scrolling
  # position. Once we have it, we can transition in all of the content.
  onImageLoad: ->
    conHeight = @getEl("image").parentNode.offsetHeight
    imgHeight = @getEl("image").offsetHeight

    @getEl("container").classList.remove("hide-description")

    @transform @getEl("image"),
      opacity: 1
      transition: "all 300ms"

    for el, i in @getEl("answers")
      @transform el,
        opacity: 1
        transition: "all 300ms #{i * 100}ms"

    @game.extra.set(animateImage: false)

    window.setTimeout (=>
      @game.extra.set
        animateImage: true

      @transition(@getEl("image"), "")
      @transition(el, "") for el, i in @getEl("answers")
    ), 600

  # The image is moved up and down every time the remaining time is updated,
  # and the background of each answer becomes more opaque the closer it is to
  # the vertical level of the image.
  onTimerChange: (m) ->
    super

    if @game.extra.get("animateImage") and
       m.changed.passed? and
       @getEl("image")?

      image = @getEl("image")
      percent = @getPercent()
      
      # always recalculate using the most up to date value
      # utilising a store value in Backbone.Model will not give an accurate result
      # when the screen resized
      position = (image.parentNode.offsetHeight - image.offsetHeight) * percent

      @transform @getEl("image"),
        y: position

      for el, i in @getEl("answers") when not el.classList.contains("selected")
        alpha = (1 - Math.abs(@getDist(i, percent))) * 0.4
        el.style.backgroundColor = "rgba(255, 255, 255, #{alpha})"

  checkAnswer: (e) ->
    return if @game.timer.get("paused") or
              @getEl("container").classList.contains("hide-attributes")

    el = e.currentTarget

    { isCorrect, index } = el.dataset

    distance = Math.abs(@getDist(index, @getPercent())) # range = {0..1}  0 = closer, 1 = further
    threshold = 0.2
    return if distance > threshold # select element only if the image is aligned with the description

    el.classList.add("selected")

    isComplete =
      _.chain(@getEl("answers"))
        .filter((el) ->
          el.dataset.isCorrect? and not el.classList.contains("selected")
        ).isEmpty()
        .value()

    if isCorrect?
      @onCorrectAnswer
        score: 1000
        time:  if isComplete then 1000 else 0
        tally: true

    else
      @onIncorrectAnswer
        time: 1000
        tally: true

    if isComplete or not isCorrect?
      @showDescription()

  showDescription: ->
    @getEl("container").classList.add("hide-attributes")
    @getEl("container").scrollTop = 0
    @pauseGame()

    description = @templates.description
      image: @data.variant.lastValue.image
      paragraphs: @data.variant.lastValue.description.split(/\n+/)

    @getEl("container").innerHTML = description

  hideDescription: ->
    @answeredCount += 1
    @getEl("container").classList.add("hide-description")

    window.setTimeout (=>
      @getEl("container").classList.remove("hide-attributes")

      if @game.timer.get("isDisabled") and @answeredCount is @getArray("variant").length
        @endGame()
        return
      
      @showNext()

      if not @game.timer.get("isDisabled")
        @game.timer.trigger "count", {
          callback: =>
            @game.timer.trigger "start", {
              callback: => @endGame()
            }
        }
    ), 600

  # How long it takes to loop back and forth
  getDuration: ->
    3000

  # The value from 0 to 1 in the loop based on the sine position of a curve
  # with a period specified by @getDuration.
  getPercent: ->
    timeDiff = Date.now() - @game.timer.timestamp
    duration = @getDuration()
    circle   = 2 * Math.PI

    (1 - Math.sin(timeDiff * circle / duration)) / 2

  # How far away from the nth answer at the current percent between 0 and 1
  getDist: (i, percent) ->
    Math.abs (i / (@getEl("answers").length - 1) - percent)

module.exports = GameElevatorView
